import { render, staticRenderFns } from "./CheckBoxInput.vue?vue&type=template&id=b1946550&"
import script from "./CheckBoxInput.vue?vue&type=script&lang=js&"
export * from "./CheckBoxInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports